!function () {
  "use strict";

  function e(t) {
    return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    }, e(t)
  }

  function t(t) {
    var r = function (t, r) {
      if ("object" !== e(t) || null === t) return t;
      var o = t[Symbol.toPrimitive];
      if (void 0 !== o) {
        var n = o.call(t, r || "default");
        if ("object" !== e(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.")
      }
      return ("string" === r ? String : Number)(t)
    }(t, "string");
    return "symbol" === e(r) ? r : String(r)
  }

  function r(e, r) {
    for (var o = 0; o < r.length; o++) {
      var n = r[o];
      n.enumerable = n.enumerable || !1,
        n.configurable = !0,
        "value" in n && (n.writable = !0),
        Object.defineProperty(e, t(n.key), n)
    }
  }

  function o(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e
  }

  function n(e, t) {
    return n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e
    }, n(e, t)
  }

  function a(e) {
    return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e)
    }, a(e)
  }

  function i(e, t, r) {
    return i = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {}))), !0
      } catch (e) {
        return !1
      }
    }() ? Reflect.construct.bind() : function (e, t, r) {
      var o = [null];
      o.push.apply(o, t);
      var a = new(Function.bind.apply(e, o));
      return r && n(a, r.prototype), a
    }, i.apply(null, arguments)
  }

  function c(e) {
    var t = "function" == typeof Map ? new Map : void 0;
    return c = function (e) {
      if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
      var r;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, o)
      }

      function o() {
        return i(e, arguments, a(this).constructor)
      }

      return o.prototype = Object.create(e.prototype, {
        constructor: {
          value: o,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n(o, e)
    }, c(e)
  }

  function l() {
    document.querySelectorAll(".js-qty__adjust").forEach((function (e) {
      e.addEventListener("click", (function () {
        var e = this.previousElementSibling;
        e || (e = this.nextElementSibling);
        var t = parseInt(e.value.replace(/\D/g, ""));
        t = u(t),
          this.classList.contains("js-qty__adjust--plus") ?
          s(t += 1) :
          ((t -= 1) <= 1 && (t = 1), s(t)),
          e.value = t
      }))
    }))
  }

  function u(e) {
    return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), e
  }

  function s(e) {
    var t = document.querySelector("#productSelect option:checked"),
      r = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g,
      o = t ? t.textContent.match(r) : null;

    if (o || (r = /([0-9]+[.|,][0-9]+)/g, o = t.textContent.match(r)), o) {
      var n;
      n = o[0];
      var a = parseInt(n.replace(/[.|,]/g, "")) * (e || parseInt(document.querySelector("#Quantity").value, 10));
      var i = Shopify.formatMoney(a, window.money_format);
      r = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g,
        i.match(r) || (r = /([0-9]+[.|,][0-9]+)/g),
        i = i.match(r)[0];

      var c = document.querySelector(".engoj_price_main").textContent;
      r = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g,
        c.match(r) || (r = /([0-9]+[.|,][0-9]+)/g),
        c = c.match(r)[0];

      var l = new RegExp(c, "g"),
        u = document.querySelector(".engoj_price_main").innerHTML.replace(l, i);

      document.querySelector(".engoj_price_main").innerHTML = u
    }
  }

  function d(e, t) {
    e.querySelector("[data-add-to-cart]").disabled = !0;
    var r = document.querySelector(".qty-error");
    r && r.remove(),
      function (e) {
        var t = new FormData(e);
        return fetch("/cart/add.js", {
          method: "POST",
          body: t
        }).then((function (e) {
          if (!e.ok) throw new Error("The quantity you entered is not available.");
          var t = new Event("cartUpdateSuccess");
          return window.dispatchEvent(t), e.json()
        })).catch((function (e) {
          var t = new Event("cartUpdateFail");
          throw window.dispatchEvent(t), e
        }))
      }(e).then((function () {
        e.querySelector("[data-add-to-cart]").disabled = !1, t && t()
      }))
  }

  function f(t) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {}))), !0
      } catch (e) {
        return !1
      }
    }();

    return function () {
      var n, i = a(t);
      if (r) {
        var c = a(this).constructor;
        n = Reflect.construct(i, arguments, c)
      } else n = i.apply(this, arguments);
      return function (t, r) {
        if (r && ("object" === e(r) || "function" == typeof r)) return r;
        if (void 0 !== r) throw new TypeError("Derived constructors may only return object or undefined");
        return o(t)
      }(this, n)
    }
  }

  var p = function (e) {
    ! function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && n(e, t)
    }(u, e);

    var t, a, i, c = f(u);

    function u() {
      var e;
      ! function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
      }(this, u),
      (e = c.call(this)).form = e.querySelector("form"),
        e.form.addEventListener("submit", e.onSubmitHandler.bind(o(e)));

      var t = e.querySelector(".product-form__personalize-input"),
        r = e.querySelector(".product-form__error-message"),
        n = e.querySelector("#personalize-toggle");

      l();

      document.addEventListener("change", (function (e) {
        var t = e.target;
        if (t.matches('.swatch input[type="radio"]')) {
          var r = t.closest(".swatch").getAttribute("data-option-index"),
            o = t.value,
            n = t.closest("form");
          n &&
            (n.querySelectorAll(".single-option-selector")[r].value = o,
              n.querySelectorAll(".single-option-selector")[r].dispatchEvent(new Event("change")))
        }
      }));

      new Shopify.OptionSelectors("productSelect", {
        product: JSON.parse(e.form.querySelector("[data-product-json]").textContent),
        onVariantSelected: e.selectCallback,
        enableHistoryState: !0
      });

      document.querySelector("[data-buy-now]") &&
        document.querySelector("[data-buy-now]").addEventListener("click", (function (e) {
          n && n.checked ?
            "" != t.value ?
            (t.classList.remove("input--error"), r.classList.add("hide"), r.classList.remove("show"),
              d(e.target.closest("form"), (function () {
                window.location.href = "/checkout"
              }))) :
            (t.classList.add("input--error"), r.classList.remove("hide"), r.classList.add("show")) :
            d(e.target.closest("form"), (function () {
              window.location.href = "/checkout"
            }))
        }));

      var a = document.getElementById("product-customizer-link");
      if (a && a.addEventListener("click", (function (e) {
          var t = e.target;
          if (t) {
            t.disabled = !0,
              t.style.cursor = "wait";
            var r = t.dataset.productId,
              o = t.dataset.modelName,
              n = document.querySelector("[name='options[Size]']");
            if (window.sessionStorage.removeItem("dormie__designSettings"),
              window.sessionStorage.setItem("dormie__customizerProductName", o),
              window.sessionStorage.setItem("dormie__customizerProductID", r), n) {
              var a = n.value;
              window.sessionStorage.setItem("dormie__customizerProductVariant", a)
            }
            setTimeout((function () {
              window.location.href = "/pages/product-customizer"
            }), 1e3)
          }
        })), document.querySelector("[data-personalize-toggle]")) {
        if (document.querySelector("[data-personalize-toggle]").addEventListener("click", (function (e) {
            if (!e.target.previousElementSibling.disabled) {
              document.getElementById("personalize-toggle").checked ?
                document.querySelector('[data-value="Non Personalized"] input[name="options[Personalize]"]').click() :
                document.querySelector('[data-value="Personalized"] input[name="options[Personalize]"]').click(),
                document.querySelector("[data-personalize-content]").classList.toggle("visible");

              var t = !1;
              document.querySelectorAll("[data-personalize-image]").forEach((function (e) {
                e.classList.contains("visible") && (e.classList.remove("visible"), t = !0)
              }));
              0 == t && document.querySelectorAll("[data-personalize-image]")[0] &&
                (document.querySelectorAll("[data-personalize-image]")[0].classList.add("visible"),
                  document.querySelectorAll("[data-personalize-font]")[0].checked = !0)
            }
          })), document.getElementById("personalize-toggle").checked) {

          document.querySelector("[data-personalize-content]").classList.toggle("visible");

          var i = !1;
          document.querySelectorAll("[data-personalize-image]").forEach((function (e) {
            e.classList.contains("visible") && (e.classList.remove("visible"), i = !0)
          }));

          0 == i && document.querySelectorAll("[data-personalize-image]")[0] &&
            (document.querySelectorAll("[data-personalize-image]")[0].classList.add("visible"),
              document.querySelectorAll("[data-personalize-font]")[0].checked = !0)
        }

        document.querySelectorAll("[data-personalize-font]").forEach((function (e) {
          e.addEventListener("click", (function () {
            document.querySelectorAll("[data-personalize-image]").forEach((function (e) {
              e.classList.remove("visible")
            })), document.getElementById(e.value).classList.add("visible")
          }))
        }))
      }
      return e
    }

    return t = u,
      (a = [{
        key: "onSubmitHandler",
        value: function (e) {
          e.preventDefault();
          var t = e.target.querySelector(".product-form__personalize-input"),
            r = e.target.querySelector(".product-form__error-message"),
            o = e.target.querySelector("#personalize-toggle");

          if (o && o.checked)
            if ("" != t.value) {
              t.classList.remove("input--error"),
                r.classList.add("hide"),
                r.classList.remove("show");
              var n = new FormData(e.target);
              if (n.get("options[Duration]") && !n.get("properties[Date]")) return;
              d(e.target)
            } else t.classList.add("input--error"),
            r.classList.remove("hide"),
            r.classList.add("show");
          else {
            var a = new FormData(e.target);
            if (a.get("options[Duration]") && !a.get("properties[Date]")) return;
            d(e.target)
          }
        }
      }, {
        key: "selectCallback",
        value: function (e) {
          if (e) {
            var t = document.querySelector("[data-buy-now]"),
              r = document.querySelector("[data-model-name]"),
              o = document.querySelector("[data-add-to-cart]");
            e.available ?
              (o.removeAttribute("disabled"),
                o.innerHTML = "Add to Cart",
                o.style.opacity = 1,
                t && (t.removeAttribute("disabled"), t.style.opacity = 1),
                r && (r.removeAttribute("disabled"), r.style.opacity = 1)) :
              (o.innerHTML = "Sold Out",
                o.disabled = !0,
                o.style.opacity = .5,
                t && (t.disabled = !0, t.style.opacity = .5),
                r && (r.disabled = !0, r.style.opacity = .5));

            var n = document.querySelector(".enj-product-price"),
              a = document.querySelector(".enj-product-price-compare");

            n.innerHTML = Shopify.formatMoney(e.price, window.money_format),
              a && (a.innerHTML = Shopify.formatMoney(e.compare_at_price, window.money_format))
          } else {
            var i = document.querySelector("[data-add-to-cart]");
            i.value = "Unavailable",
              i.disabled = !0,
              i.classList.add("disabled"),
              i.style.opacity = .5
          }
          if (e && e.featured_image) {
            var l = e.featured_image;

            // Active desktop image
            var mainDesktop = document.querySelector(
             '.product__gallery-main .splide__slide.is-active img.u-hidden-mobile-only'
            );

            // Active mobile image
            var mainMobile = document.querySelector(
             '.product__gallery-main .splide__slide.is-active img.u-hidden-desktop-up'
            );

            // Update desktop main image
            if (mainDesktop) {
             mainDesktop.src = Shopify.Image.getSizedImageUrl(l.src, '1050x1400');
             }

             // Update mobile main image
             if (mainMobile) {
            mainMobile.src = Shopify.Image.getSizedImageUrl(l.src, '600x800');
            }
            }
          document.querySelectorAll(".tab_prod [data-toggle]").forEach((function (e) {
            e.addEventListener("click", (function (t) {
              t.preventDefault(),
                document.querySelector(".tab_prod [data-toggle].active").classList.remove("active"),
                e.classList.add("active"),
                document.querySelector(".tab-pd-details .tab-pane.active").classList.remove("active"),
                document.querySelector(e.getAttribute("href")).classList.add("active")
            }))
          }))
        }
      }]) && r(t.prototype, a), i && r(t, i),
      Object.defineProperty(t, "prototype", {
        writable: !1
      }), u
  }(c(HTMLElement));

  customElements.define("product-form", p)

}();
